"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.creditReasonCodes = exports.getCreditErrorMessage = exports.creditErrors = exports.DEFAULT_CREDIT_ERROR = void 0;
var get_message_1 = require("./get-message");
var constants_1 = require("./constants");
exports.DEFAULT_CREDIT_ERROR = 'Unable to process electronic payment.';
exports.creditErrors = new Map([
    [
        'S011',
        {
            source: constants_1.SOURCES.PAYMENTS,
            ecomm: 'Card payments via SMS are unavailable. Please use a different method of payment.',
            pos: 'Card payments via SMS are unavailable. Please use a different method of payment.',
        },
    ],
    [
        'S012',
        {
            source: constants_1.SOURCES.PAYMENTS,
            ecomm: 'PrePaid Card payments are unavailable. Please use a different method of payment.',
            pos: 'PrePaid Card payments are unavailable. Please use a different method of payment.',
        },
    ],
]);
function getCreditErrorMessage(errCode, defaultMsg) {
    if (defaultMsg === void 0) { defaultMsg = exports.DEFAULT_CREDIT_ERROR; }
    return (0, get_message_1.getMessage)(exports.creditErrors, defaultMsg, errCode);
}
exports.getCreditErrorMessage = getCreditErrorMessage;
exports.creditReasonCodes = Array.from(exports.creditErrors.keys());
